module.exports = __webpack_public_path__ + "img/image_part_009.0ade2ae3.jpg";